var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClassesSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_385_1621",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_385_1621",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADVUlEQVR4nO2dv2sVQRDHz2CldqKF2igoGDTm7bykjZVYBPwD/AMiChEES5nN80djIbYWClZJIWKj1ja2WokWVlYGwfx4sxeNnlyeRd4viBfvZu7t9wNTz+x83u3tLvfYJAEAAAAMMM3tY86Ha+TlFXn5QCzr5EMWcyQaTN5dPUReHjovP7UbQMaichmO01nnZUV74GQ0KpYRrjqWTe1Bk+GoUEY6S15+9Rch74nT+UlOxyfuZ/uTyCANIQ1uH+mbplhS8mEu4WwsiRjSEEIsj3plNBdkppLkxqlcSGdp27eamis9cU2oXEhnn9H9zoh9mtIVwvKye7pK50tPWiMUnhD5uD1hvpoqPWmNqFwIeVnbnnCcswOlJ60RCkIUd6I1AEKMUSshk630JPnwzLGsah9p0A7jb61L5+60j5bdn0IUTZjLcD58024wFY/lnUipjZD8yTDQ1GxXwWGxrP4UpmjCOk1TNFSIfC+rPxpPSLWF/if+tW4IKRkIMQaEGANCjAEhxoAQY0CIMUZWyEh8u8WjtTFcqr+QMDpHJ/nBXH5Ap95UXziW88+fyupPYXaTMB9Q/iur0/Tl8lo5LO5Exm77U4jKE9YMCDEGhBgDQowBIcaAEGNAiDEgxBgQYgwIMQaEGANCjAEhxoAQY0CIMSDEGBBiDAgxBoQYA0KMASHGgBBjQIgxIMQYEGIMCDEGhBgDQowBIcaAEGNAiDEgxBgQYgwIMQaEGANCjAEhxoAQY0CIMSDEGKaETHF6ynm5SSyvHctn8tLW/uM/KYeKkGZrveG8vBh8BVLckVQthDh4YvmhPXAyGtULQWSGhWxNWc+dl8tNDieIs32lFxQ7Q2WwvKPWxlnt+qJjsIzwJsY7C03QKyO/8WCC1w5r1xUtA94bt7RrippeIU3eOKNdU9T0vz+wklKl95acqXsrB3Uripyt26C7V1jntWuKGvLypGf/8Vi7pqhpcLjYtexl2Wxwu6ldV7TMcLa39/pV4vBl+nY4rl1btBCHCwN2619pIb2kXVu0kA8PhpxrvSUOVxqt9DSOU6qEszHH4SmO34Pu8Xs32R7n0+vkZQNiggUhHfJj962bPFl+Q0zQF9J1+TDLjfwjB2L5RCzrsQtKAAAAgKQa/gCjFETt+97h1gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClassesSr);
export default __webpack_public_path__ + "static/media/menu_classes_sr.b44da44f911cbc7e4c3dedc8434e3892.svg";
export { ForwardRef as ReactComponent };